import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const MoreVertSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <g clipPath="url(#clip0_1356_9480)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 13.9609C6 14.3565 6.1173 14.7432 6.33706 15.0721C6.55682 15.401 6.86918 15.6573 7.23463 15.8087C7.60008 15.9601 8.00222 15.9997 8.39018 15.9225C8.77814 15.8453 9.13451 15.6549 9.41421 15.3752C9.69392 15.0954 9.8844 14.7391 9.96157 14.3511C10.0387 13.9632 9.99913 13.561 9.84776 13.1956C9.69638 12.8301 9.44004 12.5178 9.11114 12.298C8.78224 12.0782 8.39556 11.9609 8 11.9609C7.73731 11.9608 7.47717 12.0124 7.23445 12.1129C6.99174 12.2133 6.7712 12.3606 6.58545 12.5464C6.3997 12.7321 6.25239 12.9527 6.15193 13.1954C6.05148 13.4381 5.99985 13.6983 6 13.9609ZM6 7.96094C6 8.3565 6.1173 8.74318 6.33706 9.07208C6.55682 9.40098 6.86918 9.65732 7.23463 9.8087C7.60008 9.96007 8.00222 9.99968 8.39018 9.92251C8.77814 9.84534 9.13451 9.65486 9.41421 9.37515C9.69392 9.09545 9.8844 8.73908 9.96157 8.35112C10.0387 7.96316 9.99913 7.56102 9.84776 7.19557C9.69638 6.83012 9.44004 6.51776 9.11114 6.298C8.78224 6.07824 8.39556 5.96094 8 5.96094C7.73731 5.96079 7.47717 6.01242 7.23445 6.11287C6.99174 6.21333 6.7712 6.36064 6.58545 6.54639C6.3997 6.73214 6.25239 6.95267 6.15193 7.19539C6.05148 7.43811 5.99985 7.69825 6 7.96094ZM6 1.96094C6 2.3565 6.1173 2.74318 6.33706 3.07208C6.55682 3.40098 6.86918 3.65732 7.23463 3.8087C7.60008 3.96007 8.00222 3.99968 8.39018 3.92251C8.77814 3.84534 9.13451 3.65486 9.41421 3.37515C9.69392 3.09545 9.8844 2.73908 9.96157 2.35112C10.0387 1.96316 9.99913 1.56102 9.84776 1.19557C9.69638 0.830119 9.44004 0.517761 9.11114 0.297999C8.78224 0.0782357 8.39556 -0.0390622 8 -0.0390623C7.73731 -0.0392125 7.47717 0.0124165 7.23445 0.112873C6.99174 0.213329 6.7712 0.360642 6.58545 0.546389C6.3997 0.732136 6.25239 0.952674 6.15193 1.19539C6.05148 1.43811 5.99985 1.69825 6 1.96094Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_1356_9480">
            <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default MoreVertSVG;
